import { render } from "./SearchQuestionByCategoryContent.vue?vue&type=template&id=50f76c47&scoped=true"
import script from "./SearchQuestionByCategoryContent.vue?vue&type=script&lang=js"
export * from "./SearchQuestionByCategoryContent.vue?vue&type=script&lang=js"

import "./SearchQuestionByCategoryContent.vue?vue&type=style&index=0&id=50f76c47&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f76c47"]])

export default __exports__